import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { electronicsPageData, electronicsFAQs } from "./ElectronicsFacilities";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForElectronics() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <>
      <BazAIHelmet
        title="AI-Powered Procurement for Electronics Companies"
        description="EkkBaz AI helps electronics companies reduce procurement costs by 35%, manage supply chain risk, automate RoHS/REACH compliance, and build resilient supplier networks with AI-powered intelligence."
        keywords="electronics procurement software, semiconductor supply chain AI, RoHS compliance management, electronics supplier management, component procurement automation"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/industry/electronics`}
        industryName="Electronics"
        faqItems={electronicsFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Electronics"
        subtitle="Navigate supply chain complexity, automate RoHS/REACH compliance, and reduce procurement costs by 35% — with AI built for electronics precision."
        from="electronics"
      />
      <EnhancedPageLayout {...electronicsPageData} />
      <UpdateFooter />
    </>
  );
}
